<div class="card__header">
  <h2>Dados do usuário</h2>
  <span class="close-btn material-icons" (click)="closeSideNav()"> close </span>
</div>

<section class="card__section">
  <pl-alert color="success">
    <span header>Usuário editado com sucesso!</span>
  </pl-alert>
  <pl-info-card></pl-info-card>
</section>

@if (details$ | async; as logon) {
  <pl-action-footer>
    @if (!showResetButton && logon?.status !== 'BLOCKED') {
      <seds-basic-button
        title="Concluir"
        (click)="closeSideNav()"
      ></seds-basic-button>
    }
    @if (showResetButton && logon?.status !== 'BLOCKED') {
      <div class="action-footer__back" (click)="closeSideNav()">
        <span class="material-icons">arrow_back_ios</span>
        <span>Voltar</span>
      </div>
      <seds-basic-button
        title="Redefinir senha do usuário"
        (click)="sidenavManagerService.startResetFlow('true')"
      ></seds-basic-button>
    }
    @if (logon?.status === 'BLOCKED' && canUserSeeUnblockedOption(logon)) {
      <div class="action-footer__back" (click)="closeSideNav()">
        <span class="material-icons">arrow_back_ios</span>
        <span>Voltar</span>
      </div>
      <seds-basic-button
        title="Desbloquear usuário"
        (click)="sidenavManagerService.startUnblockUserFlow()"
      ></seds-basic-button>
    }
  </pl-action-footer>
}
